export default __webpack_public_path__ + "static/media/in-touch-linear.dd71b56a.png";